import { render, staticRenderFns } from "./UserAccountRequests.vue?vue&type=template&id=abe88b46&"
import script from "./UserAccountRequests.vue?vue&type=script&lang=js&"
export * from "./UserAccountRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports